import { PlusCircleIcon } from "lucide-react";
import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@repo/ui/components/Base/Dialog";
import { AgendaItemForm } from "./AgendaItemForm";
import { cn } from "@repo/shared/utils";
import { Tooltip } from "@repo/ui/components/Base/Tooltip";
import { AGENDA_ITEM_MOTIF } from "@/lib/constants";
import { CreateTriggerButton } from "@repo/ui/components/Base/CreateTriggerButton";
import type { AgendaItemDto } from "@/repositories/agendaItemRepo";

export const CreateAgendaItemDialog = ({
  tenantId,
  disabled,
  open: outerOpen,
  setOpen: outerSetOpen,
  initialData,
  addAnother = true,
  fullButton,
}: {
  tenantId: string;
  disabled?: boolean;
  open?: boolean;
  setOpen?: (open: boolean) => void;
  initialData?: Partial<AgendaItemDto>;
  addAnother?: boolean;
  fullButton?: boolean;
}) => {
  const [innerOpen, innerSetOpen] = useState(false);

  const controlled = outerOpen != null;
  const open = outerOpen ?? innerOpen;
  const setOpen = outerSetOpen ?? innerSetOpen;

  const handleOpenChange = () => setOpen(!open);
  const handleAddAnother = () => setOpen(true);

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      {controlled ? (
        <DialogTrigger className="hidden" />
      ) : (
        <Tooltip
          label={
            disabled
              ? "Select a team to create a request / agenda item"
              : "Create a Request / Agenda Item"
          }
          tooltipTriggerProps={{ disabled: disabled }}
          asChild
        >
          <DialogTrigger asChild={!fullButton}>
            {fullButton ? (
              <div
                className={cn(
                  "flex flex-row justify-around bg-primary text-primary-foreground rounded-lg p-2 items-center",
                  disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
                )}
              >
                {" "}
                {fullButton && "Create Request"}
                <PlusCircleIcon
                  className={cn(
                    "text-primary-foreground ml-2",
                    disabled && "opacity-100"
                  )}
                />
              </div>
            ) : (
              <CreateTriggerButton disabled={disabled} />
            )}
          </DialogTrigger>
        </Tooltip>
      )}
      <DialogContent preventClickout preventEscape>
        <DialogHeader className={AGENDA_ITEM_MOTIF}>
          <DialogTitle>Create An Agenda Item</DialogTitle>
        </DialogHeader>
        <AgendaItemForm
          tenantId={tenantId}
          partialAgendaItemFormData={{
            ...initialData,
          }}
          handleCancel={handleOpenChange}
          handleComplete={handleOpenChange}
          addAnother={addAnother ? handleAddAnother : undefined}
          withinDialog
        />
      </DialogContent>
    </Dialog>
  );
};
